import React, { useRef, useState } from "react";
import phoneIcon from "../../assets/PhoneCall.png";
import mailIcon from "../../assets/EnvelopeSimple.png";
import person from "../../assets/Person.png";
import mail from "../../assets/mail.png";
import {
  ConnectSocialTitle,
  ContectBtn,
  FromDescription,
  FromEmail,
  FromMainTitle,
  FromPhone,
} from "../../content/product";
import { GetInTouch } from "./styled";
function ContactForm() {

  const cltName = useRef("*****")
  const cltEmail = useRef("*****")
  const [isButtonDistabled, setIsButtonDistabled] = useState(false)

  const buttonClicked = () =>{

    let data_send = {}
    data_send["Name"] = cltName.current
    data_send["Email"] = cltEmail.current
    data_send["Subject"] = "NA"
    data_send["Company"] = "NA"
    data_send["Message"] = "NA"
    setIsButtonDistabled(true)
    pushToLoki(JSON.stringify(data_send))
  }

  async function pushToLoki(DATA) {
  try {
    const url = "https://api.cephlon.tech/common/pushMessage";

    // ---- Create nanosecond timestamp like your Java code ----
    const epochMillis = Date.now(); // ms since epoch
    const nanoAdjustment = Math.floor(performance.now() * 1_000_000) % 1_000_000;
    const epochNanos = (epochMillis * 1_000_000) + nanoAdjustment;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: DATA,
    });

    if (!response.ok) {
      console.log("Loki push failed:", response.status);
    } else {
      // Optional success log
      // console.log("Log pushed to Loki");
    }
  } catch (error) {
    console.log("Exception from pushToLoki:", error);
  }
};


  return (
    <GetInTouch className="website-container">
      <div className="touch-bg">
        <div className="table-content-wrapper">
          <div className="table-content">
            <div className="heading-getIn">
              <h3 className="text-getIn">{FromMainTitle}</h3>
              <p className="text-pere">{FromDescription}</p>
            </div>
            <div className="contect-area">
              <div className="contect-left">
                <div className="contectByMailAndPhone">
                  <div className="contectByPhone">
                    <img src={phoneIcon} alt="phone" />
                    <p>{FromPhone}</p>
                  </div>
                  <div className="contectByMail">
                    <img src={mailIcon} alt="mail" />
                    <p>{FromEmail}</p>
                  </div>
                </div>
                <div className="contectBySM">
                  <h6 className="smTitle">{ConnectSocialTitle}</h6>
                  {/* <div className="socialMedia">
                    <img src={faceBook} alt="facebook" />
                    <img src={linkdin} alt="linkdin" />
                    <img src={instragram} alt="instragram" />
                    <img src={twitter} alt="twitter" />
                  </div> */}
                </div>
              </div>
              <div className="contect-right">
                <div className="nameWrapper">
                  <input className="nameInput" placeholder="Full Name" onChange={(data)=>{cltName.current = data.target.value}}/>
                  <img src={person} className="personeImg" alt="Person icon" />

                </div>
                <div className="emailWrapper">
                  <input className="emailInput" placeholder="Email" onChange={(data)=>{cltEmail.current = data.target.value}}/>
                  <img src={mail} className="personeImg" alt="" />
                </div>
                <button className="contect-btn btn-hover" disabled={isButtonDistabled} onClick={()=>{buttonClicked()}}>{ContectBtn}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GetInTouch>
  );
}

export default ContactForm;
